export const round3 = (x) => Number(x).toFixed(3);

export const round = (x) => Math.round(x * 100) / 100;
